import React from "react"
import { useTheme } from "@emotion/react"
import { Box, Icon } from "@indeed/ifl-components"
import { Certification, Clock, Company, Home, Jobs, Language, MoneyStack, Patent, Profile, Waffle } from "@indeed/ifl-icons"
import { Location as LocationIcon } from "@indeed/ifl-icons/Location"
import type { IndeedTheme } from "@indeed/ifl-themes"
import { IPreferenceCategory } from "./feedback-form-model"

const PreferenceCategoryIconsMap = {
    JOB_TITLE: Profile,
    JOB_TYPE: Jobs,
    SCHEDULE: Clock,
    PAY: MoneyStack,
    LOCATION: LocationIcon,
    REMOTE: Home,
    COMPANY: Company,
    JOB_CATEGORY: Waffle,
    LANGUAGE: Language,
    EDUCATION: Patent,
    CERTIFICATION: Certification,
    LICENSE: Certification,
    SKILL: Certification,
} as const

export const PreferenceSlashableIcon: React.FC<{ category: IPreferenceCategory; isSlashed: boolean }> = (props) => {
    const { category, isSlashed } = props
    const { colors } = useTheme() as IndeedTheme
    const CategoryIcon = PreferenceCategoryIconsMap[category]

    return (
        <Box sx={{ position: "relative" }}>
            <Icon
                aria-hidden
                sx={{
                    position: "absolute",
                    insetBlockStart: 0,
                    insetInlineStart: 0,
                    display: isSlashed ? undefined : "none",
                    inlineSize: "2rem",
                    blockSize: "2rem",
                }}
            >
                <svg aria-hidden>
                    <rect
                        style={{
                            transform: "rotate(-45deg) translate(-51%, 47%)",
                            strokeWidth: "1.0.3125rem",
                        }}
                        x={0}
                        y={0}
                        width="25px"
                        height="3.5px"
                        fill={colors.foreground.status.critical["[base]"]}
                        stroke={colors.foreground.inverse["[base]"]}
                    />
                </svg>
            </Icon>
            {CategoryIcon === Clock ? (
                <Clock variant="filled" color="foreground.weak" aria-hidden />
            ) : (
                <CategoryIcon color="foreground.weak" aria-hidden />
            )}
        </Box>
    )
}
